// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1l_7j","colLarge":"styles_colLarge__WCpRc","col":"styles_col__1uftq","colCheckbox":"styles_colCheckbox__3HQTA","actions":"styles_actions__1mcyT"};